import './styles.scss';

import { CSSProperties, ReactElement } from 'react';

import { FileUploader } from 'react-drag-drop-files';
import { getClasses } from '@/utils';
import useLocale from '@/hooks/useLocale';

type FileUploaderProps = {
  name?: string;
  multiple?: boolean;
  label?: string;
  uploadedLabel?: string;
  required?: boolean;
  disabled?: boolean;
  hoverTitle?: string;
  fileOrFiles?: File | File[];
  classes?: string;
  types?: string[];
  onTypeError?: (err: string) => void;
  children?: ReactElement;
  maxSize?: number;
  minSize?: number;
  onSizeError?: (err: string) => void;
  onDrop?: (files: File | File[]) => void;
  onSelect?: (files: File | File[]) => void;
  handleChange?: (files: File | File[]) => void;
  onDraggingStateChange?: (isDragging: boolean) => void;
  dropMessageStyle?: CSSProperties;
};
export type FileInputProps = Omit<FileUploaderProps, 'classes' | 'handleChange' | 'fileOrFiles'> & {
  value?: File | File[];
  className?: string;
  onChange?: (files: File | File[]) => void;
  locale?: Record<string, string>;
};

const FileInput = ({ className, onChange, value, children, locale: customLocale = {}, ...props }: FileInputProps): ReactElement => {
  const locale = useLocale(customLocale);

  return (
    <FileUploader {...props} classes={getClasses('FileInput', className)} handleChange={onChange} fileOrFiles={value}>
      {children || (
        <div className="d-flex flex-column mb-1">
          <span className="text-center">
            <i className="fa fa-2x fa-file-lines text-secondary my-2" />
          </span>
          <span className="m-0 d-flex gap-1 justify-content-center">
            <span>{locale('Drag and Drop or')}</span>
            <strong>{locale('Browse')}</strong>
          </span>
        </div>
      )}
    </FileUploader>
  );
};

export default FileInput;
